import { TuningGroup } from '@/tunings/types';

const Life: TuningGroup = {
    id: 'PlayerLife',
    name: 'Life',
    description: '#nolife',
    properties: [
        {
            decimals: 0,
            name: 'AFK Check Interval',
            id: 'afkTime',
            step: 1,
            default: 120,
        },
        {
            decimals: 0,
            name: 'Default Health Points',
            id: 'defaultHP',
            step: 1,
            default: 100,
        },
        {
            decimals: 0,
            name: 'Default Energy',
            id: 'defaultEnergy',
            step: 1,
            default: 70,
        },
        {
            decimals: 0,
            name: 'Default Balance',
            id: 'defaultBalance',
            step: 1,
            default: 100,
        },
        {
            name: 'Can ragdoll?',
            id: 'shouldRagdoll',
            default: true,
        },
        {
            name: 'Can respawn?',
            id: 'canRespawn',
            default: false,
        },
        {
            decimals: 1,
            name: 'Default Unrag Time',
            id: 'defaultUnragTime',
            step: 0.1,
            default: 3.0,
        },
        {
            decimals: 0,
            name: 'Low Stamina Threshold',
            id: 'lowStamina',
            step: 1,
            default: 40,
        },
        {
            decimals: 0,
            name: 'Super Low Stamina Threshold',
            id: 'superLowStamina',
            step: 1,
            default: 25,
        },
        {
            decimals: 2,
            name: 'Low Stamina Unrag Modifier',
            id: 'lowStaminaUnragMod',
            step: 0.05,
            default: 0.85,
        },
        {
            decimals: 1,
            name: 'Super Low Stamina Unrag Modifier',
            id: 'superLowStaminaUnragMod',
            step: 0.1,
            default: 1.6,
        },
        {
            decimals: 0,
            name: 'Breathing Threshold',
            id: 'breathingThreshold',
            step: 1,
            default: 15,
        },
        {
            decimals: 0,
            name: 'Jump Balance',
            id: 'jumpBalance',
            step: 1,
            default: 5,
        },
        {
            decimals: 0,
            name: 'Stand Balance',
            id: 'standBalance',
            step: 1,
            default: 50,
        },
        {
            decimals: 0,
            name: 'Crouch Balance',
            id: 'crouchBalance',
            step: 1,
            default: 80,
        },
        {
            decimals: 0,
            name: 'Prone Balance',
            id: 'proneBalance',
            step: 1,
            default: 100,
        },
        {
            decimals: 0,
            name: 'Stand Move Balance',
            id: 'standMoveBalance',
            step: 1,
            default: 30,
        },
        {
            decimals: 0,
            name: 'Stand Aim Move Balance',
            id: 'standAimMoveBalance',
            step: 1,
            default: 49,
        },
        {
            decimals: 0,
            name: 'Crouch Move Balance',
            id: 'crouchMoveBalance',
            step: 1,
            default: 60,
        },
        {
            decimals: 0,
            name: 'Crouch Move Aim Balance',
            id: 'crouchMoveAimBalance',
            step: 1,
            default: 70,
        },
        {
            decimals: 0,
            name: 'Prone Move Balance',
            id: 'proneMoveBalance',
            step: 1,
            default: 90,
        },
        {
            decimals: 0,
            name: 'Zipline Balance',
            id: 'ziplineBalance',
            step: 1,
            default: 50,
        },
        {
            decimals: 0,
            name: 'Balance Down Speed',
            id: 'balanceDownSpeed',
            step: 1,
            default: 10,
        },
        {
            decimals: 0,
            name: 'Balance Up Speed',
            id: 'balanceUpSpeed',
            step: 1,
            default: 2,
        },
        {
            decimals: 1,
            name: 'Stance Energy Effect',
            id: 'stanceEnergyEffect',
            step: 0.1,
            default: [
                3.0,
                3.0,
                3.0,
                -10.0,
                -25.0,
                0.0,
                0.0,
                3.0,
                -25.0,
                0.0,
            ],
        },
        {
            decimals: 0,
            name: 'Explosion Air Kill Distance',
            id: 'explosionAirKillDistance',
            step: 1,
            default: 3,
        },
        {
            decimals: 1,
            name: 'Blood Drip Rate',
            id: 'bloodDripRate',
            step: 0.1,
            default: 0.9,
        },
        {
            decimals: 0,
            name: 'Blood HP Threshold',
            id: 'bloodHPThreshold',
            step: 1,
            default: 30,
        },
    ],
};

export default Life;
